"use strict";

var __createBinding = Object.create ? function (e, t, i, n) {
  void 0 === n && (n = i), Object.defineProperty(e, n, {
    enumerable: !0,
    get: function get() {
      return t[i];
    }
  });
} : function (e, t, i, n) {
  void 0 === n && (n = i), e[n] = t[i];
},
    __setModuleDefault = Object.create ? function (e, t) {
  Object.defineProperty(e, "default", {
    enumerable: !0,
    value: t
  });
} : function (e, t) {
  e.default = t;
},
    __importStar = function __importStar(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (null != e) for (var i in e) {
    "default" !== i && Object.hasOwnProperty.call(e, i) && __createBinding(t, e, i);
  }
  return __setModuleDefault(t, e), t;
},
    __importDefault = function __importDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DotsNavigation = void 0;

var react_1 = __importDefault(require("react")),
    Utils = __importStar(require("../utils"));

exports.DotsNavigation = function (e) {
  var o = e.state,
      a = e.onClick,
      u = e.onMouseEnter,
      l = e.onMouseLeave,
      c = e.renderDotsItem,
      s = o.itemsCount,
      d = o.itemsInSlide,
      _ = o.infinite,
      f = o.autoWidth,
      v = o.activeIndex,
      m = Utils.getSlideItemInfo(o).isNextSlideDisabled,
      g = Utils.getDotsNavigationLength(s, d, f);
  return react_1.default.createElement("ul", {
    className: "alice-carousel__dots"
  }, Array.from({
    length: s
  }).map(function (e, t) {
    if (t < g) {
      var i = Utils.checkIsTheLastDotIndex(t, Boolean(_), g),
          n = Utils.getItemIndexForDotNavigation(t, i, s, d),
          r = Utils.getActiveSlideIndex(m, o);
      f && ((r = v) < 0 ? r = s - 1 : s <= v && (r = 0), n = t);
      i = r === t ? " __active" : "", r = c ? " __custom" : "";
      return react_1.default.createElement("li", {
        key: "dot-item-" + t,
        onMouseEnter: u,
        onMouseLeave: l,
        onClick: function onClick() {
          return a(n);
        },
        className: "alice-carousel__dots-item" + i + r
      }, c && c({
        isActive: i,
        activeIndex: t
      }));
    }
  }));
};